import { NavLink } from 'react-router-dom'

// Tabs across the top of the Expenses pages, like the other sections.
export default function ExpenseTabs() {
  const tabs = [
    { to: '/operating', label: 'Summary', end: true },
    { to: '/operating/expenses', label: 'Expenses' },
  ]
  return (
    <nav className="section-tabs" aria-label="Expenses">
      {tabs.map(({ to, label, end }) => <NavLink key={to} to={to} end={end}>{label}</NavLink>)}
    </nav>
  )
}
